import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { IResource, Resource } from "@/model/Resource";
import { TriState } from "./Enums";

export interface IVisitAnswer {
    visitID: string;
    pagePartID: string;
    question: string;
    givenAnswer: string;
    photoResourceID: string;
    correctAnswer: string;
    isCorrect: TriState;
    isTest: boolean;
    isRedLine: boolean;
    created: Date;

    photoResource: IResource;
}

export class VisitAnswer implements IVisitAnswer {

    constructor(data?: IVisitAnswer) {
        if (data) this.update(data);
    }

    update(data: IVisitAnswer): VisitAnswer {
        mapData(data, {
            root: () => this,
            photoResource: (data: IResource) => this.photoResource.update(data)
        });
        return this;
    }

    visitID: string = Utils.emptyGuidValue;
    pagePartID: string = Utils.emptyGuidValue;
    question: string = "";
    givenAnswer: string = "";
    photoResourceID: string = Utils.emptyGuidValue;
    correctAnswer: string = "";
    isCorrect: TriState = TriState.UseDefault;
    isTest: boolean = false;
    isRedLine: boolean = false;
    created: Date = new Date(Utils.emptyDateValue);

    photoResource: Resource = new Resource();

    get isAnswered() {
        return this.isCorrect !== TriState.UseDefault;
    }

    get hasPhoto() {
        return !Utils.isEmptyId(this.photoResourceID);
    }

    get isNew() {
        return Utils.hasDateValue(this.created);
    }

    static create(visitID: string, pagePartID: string): IVisitAnswer{
        return {
            visitID: visitID,
            pagePartID: pagePartID,
            question: "",
            givenAnswer: "",
            correctAnswer: "",
            photoResourceID: Utils.emptyGuidValue,
            isCorrect: TriState.UseDefault,
            isTest: false,
            isRedLine: false,
            created: new Date(Utils.emptyDateValue),
            photoResource: new Resource()
        };
    }
}


